export default __webpack_public_path__ + "static/media/newsletter.97cd4aea.svg";